



























import { Component, Mixins, Prop } from 'vue-property-decorator'
import BadgeDoCliente from './BadgeDoCliente.vue'
import CampoComTitulo from './CampoComTitulo.vue'
import CoresDoPainel from './CoresDoPainel'
import MetricasDoCliente from './MetricasDoCliente.vue'
import PosicaoNaLojaRfv from './PosicaoNaLojaRfv.vue'
import type { PerfilDoCliente } from '@/models'
import { buscarPerfil } from '@/api/painelDoCliente'
import { criarCachePorTempo } from '@/shareds/cache-por-tempo'
import {
	formatarCanalPreferido,
	formatarPerfilDeCompra,
	montarBadgesDoCliente,
	montarPosicoesRfv,
	TEXTO_SEM_DADOS,
	valorOuSemDados,
} from '@/shareds/painel-do-cliente-shareds'

const DOIS_MINUTOS_EM_MS = 2 * 60 * 1000

const buscarPerfilComCache = criarCachePorTempo<PerfilDoCliente>(DOIS_MINUTOS_EM_MS)

@Component({
	components: {
		BadgeDoCliente,
		CampoComTitulo,
		MetricasDoCliente,
		PosicaoNaLojaRfv,
	},
})
export default class PerfilEPosicaoDoCliente extends Mixins(CoresDoPainel) {
	@Prop({ type: String, required: true }) clienteId!: string
	@Prop({ type: String, required: true }) lojaId!: string

	perfil: PerfilDoCliente | null = null
	carregando = true
	textoSemDados = TEXTO_SEM_DADOS

	get badges() {
		return montarBadgesDoCliente(this.perfil)
	}

	get categoriaFavorita() {
		return valorOuSemDados(this.perfil?.preferencias?.categoriaFavorita)
	}

	get marcaFavorita() {
		return valorOuSemDados(this.perfil?.preferencias?.marcaFavorita)
	}

	get canalPreferido() {
		return formatarCanalPreferido(this.perfil?.preferencias?.canalPreferido)
	}

	get perfilDeCompra() {
		return formatarPerfilDeCompra(this.perfil?.preferencias?.tags)
	}

	get posicoes() {
		return montarPosicoesRfv(this.perfil, this.corPrimaria)
	}

	created() {
		this.carregar()
	}

	async carregar() {
		this.carregando = true
		try {
			this.perfil = await buscarPerfilComCache(
				`${this.clienteId}:${this.lojaId}`,
				() => buscarPerfil(this.clienteId, this.lojaId),
			)
		} catch (erro) {
			console.warn('Falha ao buscar o perfil do cliente para o painel do caixa', erro)
			this.perfil = null
		} finally {
			this.carregando = false
		}
	}
}
